import React, {Component} from 'react';
import PropTypes from 'prop-types';

import './email.css';

class Email extends Component {
    render() {
        return <a className="Email" href={`mailto:${this.props.email}`}>{this.props.email}</a>
    }
}

Email.propTypes = {
    email: PropTypes.string.isRequired,
};

export default Email;


// WEBPACK FOOTER //
// ./src/components/email/index.js